"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CHANGE_ORDER_TYPE = undefined;

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.changeOrderType = changeOrderType;
exports.isReceptionPlacesLoaded = isReceptionPlacesLoaded;
exports.loadReceptionPlaces = loadReceptionPlaces;
exports.confirmPage = confirmPage;
exports.formPage = formPage;
exports.resetVoucherState = resetVoucherState;
exports.getShoppingCart = getShoppingCart;
exports.deleteShoppingCart = deleteShoppingCart;
exports.insertCartItem = insertCartItem;
exports.removeCartItem = removeCartItem;
exports.updateQuantity = updateQuantity;
exports.placeOrder = placeOrder;
exports.confirmPayment = confirmPayment;

var _ShoppingCartUtil = require("../../utils/ShoppingCartUtil");

var _VoucherUtil = require("../../utils/VoucherUtil");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD_RECEPTION_PLACES = "maaporssi/vouchers/LOAD_RECEPTION_PLACES";
var LOAD_RECEPTION_PLACES_SUCCESS = "maaporssi/vouchers/LOAD_RECEPTION_PLACES_SUCCESS";
var LOAD_RECEPTION_PLACES_FAIL = "maaporssi/vouchers/LOAD_RECEPTION_PLACES_FAIL";
var CREATE_VOUCHER_ORDER = "maaporssi/vouchers/CREATE_VOUCHER_ORDER";
var CREATE_VOUCHER_ORDER_SUCCESS = "maaporssi/vouchers/CREATE_VOUCHER_ORDER_SUCCESS";
var CREATE_VOUCHER_ORDER_FAIL = "maaporssi/vouchers/CREATE_VOUCHER_ORDER_FAIL";
var CONFIRM_PAYMENT = "maaporssi/vouchers/CONFIRM_PAYMENT";
var CONFIRM_PAYMENT_FAIL = "maaporssi/vouchers/CONFIRM_PAYMENT_FAIL";
var CONFIRM_PAYMENT_SUCCESS = "maaporssi/vouchers/CONFIRM_PAYMENT_SUCCESS";
var CONFIRM = "maaporssi/vouchers/CONFIRM";
var BACK = "maaporssi/vouchers/BACK";
var GET_SHOPPING_CART = "maaporssi/vouchers/GET_SHOPPING_CART";
var RESET_VOUCHER_STATE = "maaporssi/vouchers/RESET_VOUCHER_STATE";
var CHANGE_ORDER_TYPE = exports.CHANGE_ORDER_TYPE = "maaporssi/vouchers/CHANGE_ORDER_TYPE";

var initialState = {
  orderType: _VoucherUtil.RECEPTION_ORDER_TYPE,
  placesLoaded: false,
  confirmPage: false,
  cart: []
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case CHANGE_ORDER_TYPE:
      return (0, _extends3.default)({}, state, {
        placesLoading: false,
        placesLoaded: false,
        placesError: null,
        places: null
      });
    case LOAD_RECEPTION_PLACES:
      return (0, _extends3.default)({}, state, {
        placesLoading: true
      });
    case LOAD_RECEPTION_PLACES_FAIL:
      return (0, _extends3.default)({}, state, {
        placesLoading: false,
        placesLoaded: true,
        placesError: action.error.error
      });
    case LOAD_RECEPTION_PLACES_SUCCESS:
      return (0, _extends3.default)({}, state, {
        placesLoading: false,
        placesLoaded: true,
        places: action.result
      });
    case GET_SHOPPING_CART:
      return (0, _extends3.default)({}, state, {
        cart: action.payload
      });
    case CREATE_VOUCHER_ORDER:
      return (0, _extends3.default)({}, state, {
        placeOrderLoading: true
      });
    case CREATE_VOUCHER_ORDER_FAIL:
      return (0, _extends3.default)({}, state, {
        placeOrderLoading: false,
        placeOrderError: action.error.error || "ERROR"
      });
    case CREATE_VOUCHER_ORDER_SUCCESS:
      if (action.result.status === "PENDING_PAYMENT" && action.result.payment_url) {
        window.location = action.result.payment_url;
        return state;
      }
      return (0, _extends3.default)({}, state, {
        placeOrderLoading: false,
        placeOrderSuccess: action.result
      });
    case CONFIRM:
      return (0, _extends3.default)({}, state, {
        confirmPage: true
      });
    case BACK:
      return (0, _extends3.default)({}, state, {
        confirmPage: false
      });
    case CONFIRM_PAYMENT:
      return (0, _extends3.default)({}, state, {
        confirmPaymentLoading: true
      });
    case CONFIRM_PAYMENT_FAIL:
      return (0, _extends3.default)({}, state, {
        confirmPaymentLoading: false,
        confirmPaymentLoaded: true,
        confirmPaymentError: action.error.error
      });
    case CONFIRM_PAYMENT_SUCCESS:
      return (0, _extends3.default)({}, state, {
        confirmPaymentLoading: false,
        confirmPaymentLoaded: true,
        confirmPaymentSuccess: action.result
      });
    case RESET_VOUCHER_STATE:
      return initialState;
    default:
      return state;
  }
}

function changeOrderType(orderType) {
  return {
    type: CHANGE_ORDER_TYPE,
    payload: orderType
  };
}

function isReceptionPlacesLoaded(globalState) {
  return globalState.vouchers && globalState.vouchers.placesLoaded;
}

function loadReceptionPlaces() {
  return {
    types: [LOAD_RECEPTION_PLACES, LOAD_RECEPTION_PLACES_SUCCESS, LOAD_RECEPTION_PLACES_FAIL],
    promise: function promise(client) {
      return client.get("/soil_reception_places");
    }
  };
}

function confirmPage() {
  return {
    type: CONFIRM
  };
}

function formPage() {
  return {
    type: BACK
  };
}

function resetVoucherState() {
  (0, _ShoppingCartUtil.removeItems)("reception");
  return {
    type: RESET_VOUCHER_STATE
  };
}

function createCartAction() {
  return {
    type: GET_SHOPPING_CART,
    payload: (0, _ShoppingCartUtil.getItems)("reception")
  };
}

function getShoppingCart() {
  return createCartAction();
}

function deleteShoppingCart() {
  (0, _ShoppingCartUtil.removeItems)("reception");
  return createCartAction();
}

function insertCartItem(item) {
  (0, _ShoppingCartUtil.addItem)(item, "reception");
  return createCartAction();
}

function removeCartItem(item) {
  (0, _ShoppingCartUtil.removeItem)(item, "reception");
  return createCartAction();
}

function updateQuantity(item, quantity) {
  if (quantity < 1 || isNaN(quantity)) {
    (0, _ShoppingCartUtil.updateItemQuantity)(item, 1, "reception");
  } else {
    (0, _ShoppingCartUtil.updateItemQuantity)(item, quantity, "reception");
  }
  return createCartAction();
}

function placeOrder(formData) {
  return {
    types: [CREATE_VOUCHER_ORDER, CREATE_VOUCHER_ORDER_SUCCESS, CREATE_VOUCHER_ORDER_FAIL],
    promise: function promise(client) {
      return client.post("/soil_reception_orders", {
        data: formData
      });
    }
  };
}

function confirmPayment(_ref) {
  var orderId = _ref.orderId,
      data = _ref.data;

  return {
    types: [CONFIRM_PAYMENT, CONFIRM_PAYMENT_SUCCESS, CONFIRM_PAYMENT_FAIL],
    promise: function promise(client) {
      return client.post("/soil_reception_orders/" + orderId + "/confirm", {
        data: data
      });
    }
  };
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/modules/vouchers.js
 ** module id = 312
 ** module chunks = 0
 **/